import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import axios from 'axios';
import MultipleDeletePages from '../Components/DeleteModal/MultipleDeletePages';
import SingleDeletePage from '../Components/DeleteModal/SingleDeletePage';
import NotificationMessage from '../Components/NotificationMessage';
import { DataTableList } from '../Components/DataTable/DataTable';
import PageActionDropdown from '../Components/PageActionDropdown';

import '.././App.css';

import search from '.././images/search.svg'
import clear from '.././images/delete.svg'
import more from '../images/more.svg'

function Pages(props) {

    props.setActivePage('All Pages')
    const [activeFilter, setActiveFilter] = useState('All')
    const [searchInput, setSearchInput] = useState('')
    const [pages, setPages] = useState([])
    const [allFiltered, setAllFiltered] = useState(pages)
    const [originalData, setOriginalData] = useState([]);
    const [isPopupOpenDeleteAccount, setIsPopupOpenDeleteAccount] = useState(false);
    const [isPopupSingleDeleteAccount, setIsPopupSingleDeleteAccount] = useState(false);
    const [openPopupIndex, setOpenPopupIndex] = useState(null);
    const [isOpenPopupIndex, setIsOpenIndexPopup] = useState(false);
    const [selectAll, setSelectAll] = useState(false);
    const [showMultiNotify, setShowMultiNotify] = useState(false)
    const [totalPage, setTotalPage] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedPageStatus, setSelectedPageStatus] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [showNotification, setShowNotification] = useState(false);
    const [selectedPubLenght, setSelectedPubLenght ] = useState(0)

    const [selectedRows, setSelectedRows] = useState([]);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [activateEdit, setActivateEdit] = useState(false)
    const [columnWidths, setColumnWidths] = useState([]);
    const [toggleSelect, setToggleSelect] = useState(false);
    

    const user_id = JSON.parse(localStorage.getItem("userinfo"))?._id
    const profileSlug = localStorage.getItem('userProfileSlug')
    const homagepage_id = btoa(`homepage-${user_id}`);
    const contactpage_id = btoa(`contactpage-${user_id}`);

    const data = async () => {
        const search = searchInput.toLowerCase();
        setIsLoading(false)
        try {
            setIsLoading(true);
            setIsLoadingData(true);
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/pages/pageslist/${user_id}?page=${currentPage}&search=${search}&status=${selectedPageStatus}`,
            )
            const result = response?.data?.result;
            if(result?.length <= 0){
                setIsLoadingData(false)
            }
            setOriginalData(result);
            setTotalPage(response?.data?.totalPages || 1)
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            console.log(error, "error");
        }
    }

    useEffect (()=>{
        data();
    },[user_id,currentPage, searchInput, selectedPageStatus])

    useEffect(() => {
        setCurrentPage(1);
    }, [selectedPageStatus]);

    useEffect(() => {
        searchPage()
    }, [searchInput])

    const togglePopup = (index) => {
        if (index === openPopupIndex) {
            setOpenPopupIndex(null);
            setIsOpenIndexPopup(false)
        } else {
            setOpenPopupIndex(index);
            setIsOpenIndexPopup(true)
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (openPopupIndex &&  (event.target.closest('.pagesTableAction') === null && event.target.closest('.dropdown') === null) && !document.body.classList.contains('hidden-message')) {
                togglePopup(null) // Close the dropdown
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openPopupIndex,togglePopup]);

    function searchPage() {
        var result = [];

        var input = searchInput.toLowerCase()
        originalData.forEach(element => {
            var title = element.title.toLowerCase();

            if (title.startsWith(input)) {
                result.push(element);
            }
        });

        setPages(result);
        setAllFiltered(result);

        if (result != []) {
            setPages(result)
            setAllFiltered(result)
        } else if (input === '') {
            setPages(pages)
            setAllFiltered(pages)
            setActiveFilter('All')
        } else {
            setPages([])
            setAllFiltered([])
        }
    }

    const fetchData = async () => {
        setIsLoading(false)
        try {
            setIsLoading(true)
            setIsLoadingData(true)
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/pages/pageslist/${JSON.parse(localStorage.getItem("userinfo"))?._id}?page=${currentPage}&status=${selectedPageStatus}`,
            )
            if(response?.data?.result?.length <= 0){
                setIsLoadingData(false)
            }
            setOriginalData(response?.data?.result);
            setTotalPage(response?.data?.totalPages || 1)
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            console.log(error, "error");
        }
    }

    useEffect(() => {
        fetchData();
    }, [selectedPageStatus]);


    useEffect(() => {
        setSelectAll(false);
        filterByStatus(activeFilter);
    }, [activeFilter, originalData]);

    function filterByStatus(status) {
        if (status === 'All') {
            setPages(originalData);
        } else {
            const filteredData = originalData.filter(item => item.status === status);
            setPages(filteredData);
        }
    }

    function updateOriginalData(updatedData) {
        //setOriginalData(updatedData);  
        fetchData()
    }
    useEffect(() => {
        const checkIfClickedOutside = (e) => {
          if (e.target != null && isPopupOpenDeleteAccount && (e.target.classList.contains('welcomeOverlay'))) {
            setIsPopupOpenDeleteAccount(false);
          }
          if (e.target != null && isPopupSingleDeleteAccount && (e.target.classList.contains('welcomeOverlay'))) {
            setIsPopupSingleDeleteAccount(false);
        }
        };
        document.addEventListener("mousedown", checkIfClickedOutside);
    
        return () => {
          document.removeEventListener("mousedown", checkIfClickedOutside);
        };
      }, [isPopupOpenDeleteAccount, isPopupSingleDeleteAccount]);


    const handleDelete = async () => {
        if (selectedRows.length === 1 && (selectedRows.status !== "Deleted" || selectedRows.status === "Deleted")) {
            setIsPopupSingleDeleteAccount(true);
            document.body.classList.add('hidden-message');
        }

        if (selectedRows.length > 1 && (selectedRows.status !== "Deleted" || selectedRows.status === "Deleted")) {
            setIsPopupOpenDeleteAccount(true);
            document.body.classList.add('hidden-message');
        }
    };

    const closeSingleAccountDeletedPopup = () => {
        //setSelectedItems([]);
        document.body.classList.remove('hidden-message');
        setIsPopupSingleDeleteAccount(false);
    }

    const closeAccountDeletedPopup = () => {
        //setSelectedItems([]);
        document.body.classList.remove('hidden-message');
        setIsPopupOpenDeleteAccount(false)
    }

    const updateStatus = async (itemId, newStatus) => {
        try {
            await axios.post(
                `${process.env.REACT_APP_API_URL}/pages/updatepage/${itemId}`,
                {
                    status: newStatus
                });
            fetchData();
        } catch (error) {
            console.log(error, "error");
        }
    };

    useEffect(() => {
        if (pages?.length > 0) {
            calculateColumnWidths();
        } 
    }, [pages]);
    
    useEffect(() => {
        if (Object.keys(columnWidths).length > 0) {
            setTimeout(() => {
                setIsLoadingData(false);
            }, 1000);  
        }
    }, [columnWidths]);

    function formateDate(date) {
        var createdAtDate = new Date(date);

        var options = { year: 'numeric', month: 'short', day: 'numeric' };

        var formattedDate = createdAtDate.toLocaleDateString('en-US', options);
        return formattedDate
    }

    const calculateColumnWidths = async () => {
        return new Promise((resolve) => {
            const tempWidths = pages?.reduce((acc, row) => {
                Object.keys(row).forEach((key) => {
                    const dataValue = row[key].toString();
                    const title = row[key];

                    // Compare title length with data content length and take the max

                    let maxContentLength = 0;

                    if (key === 'status') {
                        if(searchInput === '' || pages?.length > 1){
                            if(row?.status === 'Published'){
                                maxContentLength = Math.max(dataValue.length + 2);
                            } else{
                                maxContentLength = Math.max(dataValue.length + 3);
                            }
                        } else{
                            if(row?.status === 'Published'){
                                maxContentLength = Math.max(dataValue.length + 3);
                            } else{
                                maxContentLength = Math.max(dataValue.length + 3);
                            }
                        }
                    } else {
                        maxContentLength = Math.max(dataValue.length, title.length);
                    }

                    if (!acc[key] || maxContentLength > acc[key]) {
                        acc[key] = maxContentLength;
                    }
                });
                return acc;
            }, {});
            if(tempWidths !== undefined){
                const widthMap = Object.keys(tempWidths).reduce((acc, key) => {
                    if (key === 'categories') {
                        pages.forEach((row) => {
                            const categoryWidth = tempWidths[key] * 10 + 50;
                            acc[key] = `${categoryWidth}px`;
                        });
                    } else {
                        acc[key] = `${tempWidths[key] * 10 + 40}px`;
                    }
                    return acc;
                }, {});
                setColumnWidths(widthMap); // Set the calculated column widths
            }
            resolve(); // Resolve the promise once widths are set
        });
    };

    const handleMasterCheckboxChange = () => {
        if (isAllSelected) {
            setSelectedRows([]);
        } else {
            const excludedItemIds = [ homagepage_id, contactpage_id];
            const allItemIds = data.map((row) => row._id).filter((itemId) => !excludedItemIds.includes(itemId));
            setSelectedRows(allItemIds); // Select all rows
        }
        setIsAllSelected(!isAllSelected); // Toggle master checkbox
    };

    function updateActivateEdit(activateEdit) {
        setActivateEdit(activateEdit)
    }

    const changeStatus = (newStatus) => {
        data.status = newStatus;
        updateStatus(data._id, newStatus);
    };

    const customTitleSort = (rowA, rowB) => {
        const titleA = rowA?.title.toString().toLowerCase();
        const titleB = rowB?.title.toString().toLowerCase();
    
        // Natural sort comparison for mixed numbers and letters
        return titleA.localeCompare(titleB, undefined, { numeric: true, sensitivity: 'base' });
    };

    const columns = [
        {
            name: 'Title',
            selector: (row) => row?.title,
            cell: (row) => {
                return (
                    <Link className='editTitle' to={`/dashboard/page/${row?._id}`}>{row?.title}</Link>
                )
            },
            sortable: true,
            minWidth: columnWidths['title'] && (parseInt(columnWidths['title']) + 50 > 300) ? '300px' : `${parseInt(columnWidths['title']) + 50}px`,        
            sortFunction: customTitleSort,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
        },
        {
            name: 'Status',
            selector: (row) => row?.status, // Ensure this returns the status value
            cell: (row) => {
                return (
                    <div className='statusTab'><span className={(row?.status === 'Published') ? 'greenStatus' : (row?.status === 'Draft') ? 'draftStatus' : (row?.status === 'Schedule') ? 'scheduleStatus' : 'deletedStatus'}> {row?.status}</span></div>
                )
            },
            width: columnWidths['status'] || '150px',
            style: { width: columnWidths['status'] || '150px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
            sortable: true,
        },
        {
            name: 'Last Updated',
            selector: row => formateDate(row?.updatedAt),
            sortable: true,
            paddingLeft: 0,
            width: '150px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", minWidth: '150px', fontSize: "14px" },
        },
        {
            name: 'Link',
            cell: (row) => {
                let pageUrl;
                let domainUrl = 'https://jourmal-next-front.vercel.app'
                if(props?.userMetaData?.customDomain?.verified && (props?.userMetaData?.customDomain?.domain !== undefined && props?.userMetaData?.customDomain?.domain !== '')){
                    domainUrl = `https://${props?.userMetaData?.customDomain?.domain}/`
                } else{
                    domainUrl = `https://jourmal-next-front.vercel.app/${profileSlug}/`
                }
                if (row?.status === 'Published') {
                    pageUrl = `${domainUrl}${row.url_address}`;
                } else {
                    if (row.status === 'Draft' && row?.publication_type === 'Regular') {
                        pageUrl = `https://reactdashboard.codeptsolutions.com/dashboard/previewpage/${row?._id}`
                    }
                }
                return (
                    <div className='pagesTableLink'><Link target={'_blank'} to={`${pageUrl}`}><button className='pagesLinkButton'>
                        <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.88252 9.44272L7.11748 10.2078C6.06116 11.2641 4.34855 11.2641 3.29223 10.2078C2.23592 9.15146 2.23592 7.43884 3.29223 6.38252L4.05728 5.61748M10.9427 6.38252L11.7078 5.61748C12.7641 4.56116 12.7641 2.84855 11.7078 1.79223C10.6515 0.735922 8.93884 0.735922 7.88252 1.79223L7.11748 2.55728M5.6066 7.89339L9.3934 4.10659" stroke="#344054" stroke-width="1.5" strokeLinecap="round" stroke-linejoin="round" />
                        </svg>
                        {row?.status === 'Published' ? 'Link' : 'Preview'}
                    </button></Link></div>
                )
            },
            paddingLeft: 0,
            width: (columnWidths['status']  && parseInt(columnWidths['status'])) ? (searchInput === '' || pages?.length > 1) ? `${parseInt(columnWidths['status']) - 40}px` : pages?.[0]?.status !== 'Published' ? `${parseInt(columnWidths['status'])}px` :  `${parseInt(columnWidths['status']) - 60}px` : '150px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
        },
        {
            name: 'Actions',
            cell: (row) => (
                <>
                    <div className='pagesTableAction publicationAction' onClick={() => togglePopup(row)}>
                        <img src={more} alt="More" />
                    </div>
                    {
                        (isOpenPopupIndex && (openPopupIndex?._id === row?._id)) && <PageActionDropdown togglePopup={togglePopup} changeStatus={changeStatus} type={row?.type || "page"} data={row} updateActivateEdit={updateActivateEdit} updateOriginalData={updateOriginalData} index={row._id} setShowNotification={setShowNotification} />
                    }
                </>
            ),
            justifyContent: 'flex-end',
            allowOverflow: true,
            button: true,
            // minWidth: "55px",
            paddingRight: '16px',
            width: '80px',
            style: { textAlign: 'right', minWidth: '80px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px" }, // Aligning to the right
            headerStyle: { textAlign: 'right' },
        },
    ];
    const customStyles = {
        headCells: {
            style: {
                fontWeight: 500,
                fontSize: '14px',
            },
        },
    };

    const selectableRowDisabled = (row) => {
        if( row.type === 'home' || row.type === 'contact' ) {
            return true;
        }

        return false;
    }

    return (
        <section className='dashboard'>
            <Helmet>
                <title>All Pages | Dashboard | Persone</title>
            </Helmet>
            <div className="container">
                <div className="dashboardTop">
                    <div className="dashboardTopText">
                        <div className='dashboardTopLeft'>
                            <p>All Pages</p>
                            <p className="pageSubTitle">Create, edit, and organize your informational pages to showcase your work and ideas.</p>
                        </div>
                        <div className="pagesSorting pageTypeSorting">
                        <div className='pagesSearch'>
                            <div className="pageSearchInput">
                                <input type="text" name="pages_search" id="pages_search" placeholder={'Search pages...'} value={searchInput} onChange={e => setSearchInput(e.target.value)} />
                                <img src={search} alt="Search" />
                            </div>

                            <div className='deleteIcon page-deleteIcon' onClick={() => handleDelete()}>
                                <img className='deleteIconImage' src={clear} alt="Clear Input" />
                            </div>
                        </div>
                    </div>
                    </div>
                </div>

                <div className="pagesTableWrapper pages-list">
                    <div className={`pagesTable dataTable-list ${(isLoadingData) ? 'loading-list' : ''}`}>
                        <DataTableList
                            columns={columns}
                            data={pages}
                            onSelectedRowsChange={({ selectedRows }) => {
                                const selectedIds = selectedRows.map((row) => row._id);
                                setSelectedRows(selectedIds);
                                setIsAllSelected(selectedIds.length === data.length);
                            }}
                            progressPending={isLoading}
                            progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
                            onChangePage={setCurrentPage}
                            paginationTotalRows={totalPage}
                            currentPage={currentPage}
                            customStyles={customStyles}
                            selectableRowDisabled= {selectableRowDisabled}
                            selectableRowsComponent="input"
                            selectAllRows={isAllSelected}
                            onSelectAllChange={handleMasterCheckboxChange}
                            clearSelectedRows={toggleSelect}
                            type="page" 
                            name="pages"
                            selectableRows={true}
                        />
                    </div>
                </div>
            </div>

            {(isPopupOpenDeleteAccount || isPopupSingleDeleteAccount) && <div className="welcomeOverlay"></div>}

            {<SingleDeletePage isOpen={isPopupSingleDeleteAccount} onClose={closeSingleAccountDeletedPopup} data={pages} type='page' updateOriginalData={updateOriginalData} index={selectedRows} activeFilter={activeFilter} setShowNotification={setShowNotification} setSelectedItems={setSelectedRows} toggleSelect={toggleSelect} setToggleSelect={setToggleSelect}/>}
            {<MultipleDeletePages isOpen={isPopupOpenDeleteAccount} onClose={closeAccountDeletedPopup} customKey="pagesId" type='page' name="pages" selectedItems={selectedRows} updateOriginalData={updateOriginalData} activeFilter={activeFilter} setShowMultiNotify={setShowMultiNotify} setSelectedPubLenght={setSelectedPubLenght} setSelectedItems={setSelectedRows} toggleSelect={toggleSelect} setToggleSelect={setToggleSelect}/>}
            {showNotification && (
                <NotificationMessage  openNotify={showNotification} setOpenNotify={setShowNotification} type={'success'} title={`The page was successfully deleted!`} />
            )}
            {showMultiNotify && (
                <NotificationMessage  openNotify={showMultiNotify} setOpenNotify={setShowMultiNotify} type={'success'} title={`${selectedPubLenght} pages were successfully deleted!`} />
            )}
        </section>
    );
}

export default Pages;